// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"Loader_pageLoader__1jXh9","loader":"Loader_loader__3Y-to"};